// 最大缓存数
export const CACHE_LIMIT = 20

// 栏目默认图标
export const ICON_DEFAULT = 'fa-bars'

// api请求正确吗
export const SUCCESS_OK = 200

// api请求基准地址
export const BASE_URL = process.env.NODE_ENV === 'development' ? '/bluetooth-api' : '/bluetooth-api'

// 菜单权限按钮菜单
export const AUTH_BTN_LIST = {
    'orgPerson-organization': [
        {label: '组织操作', value: 'org'},
        {label: '导入导出', value: 'port'},
        {label: '用户新增', value: 'append'},
        {label: '用户编辑', value: 'edit'},
        {label: '用户删除', value: 'remove'},
        {label: '修改密码', value: 'pwd'}
    ],
    'orgPerson-role': [
        {label: '授权', value: 'auth'},
        {label: '新增', value: 'append'},
        {label: '编辑', value: 'edit'},
        {label: '删除', value: 'remove'}
    ],
    'area': [
        {label: '辖区操作', value: 'area'},
        {label: '设施新增', value: 'append'},
        {label: '设施编辑', value: 'edit'},
        {label: '设施删除', value: 'remove'}
    ],
    'key': [
        {label: '钥匙新增', value: 'append'},
        {label: '钥匙编辑', value: 'edit'},
        {label: '钥匙删除', value: 'remove'},
        {label: '导入导出', value: 'port'}
    ],
    'lock': [
        {label: '锁具新增', value: 'append'},
        {label: '锁具编辑', value: 'edit'},
        {label: '锁具删除', value: 'remove'},
        {label: '导入导出', value: 'port'}
    ]

}



// WEBPACK FOOTER //
// ./src/constant/index.js